<template>
  <div class="catalog__controls-sort catalog__header-col">
    <div class="catalog__sort sort pure-g">
      <span class="sort__caption pure-u-2-5">Сортировать по:</span>

      <div class="pure-u-3-5">
        <vue-select
            @changeSelect="onSort"
            :default="defOption"
            :options="options"
        ></vue-select>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "./VueSelect.vue"

export default {
  name: "SortBox",
  components: {VueSelect},
  data: function () {
    return {
    }
  },
  computed: {
    defOption() {
      let result = null
      if ('sort' in this.$store.getters.page)
        result = this.$store.getters.page.sort.field + '-' + this.$store.getters.page.sort.direction;

      return result;
    },
    options() {
      let result = {};
      if (this.$route.path == '/search/' || this.$route.path == '/search_archive/') {
        result = [
          {
            title: 'релевантности',
            value: 'search-asc',
          },
          {
            title: 'цене',
            value: 'price-asc',
            icon: 'icon-asc'
          },
          {
            title: 'цене',
            value: 'price-desc',
            icon: 'icon-desc'
          },
          {
            title: 'названию',
            value: 'name-asc',
          },
          {
            title: 'коду',
            value: 'code-asc',
          },
          {
            title: 'артикулу',
            value: 'vendorCode-asc',
          },
          {
            title: 'дате прихода',
            value: 'arrivalDate-desc',
          },
          {
            title: 'по новизне',
            value: 'firstArrivalDate-desc',
          },
          {
            title: 'популярности',
            value: 'leader-desc',
          },
        ];
      } else {
        result = [
          {
            title: 'умолчанию',
            value: 'id-desc'
          },
          {
            title: 'цене',
            value: 'price-asc',
            icon: 'icon-asc'
          },
          {
            title: 'цене',
            value: 'price-desc',
            icon: 'icon-desc'
          },
          {
            title: 'названию',
            value: 'name-asc',
          },
          {
            title: 'коду',
            value: 'code-asc',
          },
          {
            title: 'артикулу',
            value: 'vendorCode-asc',
          },
          {
            title: 'дате прихода',
            value: 'arrivalDate-desc',
          },
          {
            title: 'по новизне',
            value: 'firstArrivalDate-desc',
          },
          {
            title: 'популярности',
            value: 'leader-desc',
          },
        ];
      }
      return result;
    }
  },
  methods: {
    onSort: function (field) {
      let sort = {};
      let isDefault = false;
      switch (field) {
        case 'price-asc':
          sort = {
            field: 'price',
            direction: 'asc'
          };
          break;
        case 'price-desc':
          sort = {
            field: 'price',
            direction: 'desc'
          };
          break;
        case 'name-asc':
          sort = {
            field: 'name',
            direction: 'asc'
          };
          break;
        case 'search-asc':
          sort = {
            field: 'search',
            direction: 'asc'
          };
          break;
        case 'code-asc':
          sort = {
            field: 'code',
            direction: 'asc'
          };
          break;
        case 'vendorCode-asc':
          sort = {
            field: 'vendorCode',
            direction: 'asc'
          };
          break;
        case 'arrivalDate-desc':
          sort = {
            field: 'arrivalDate',
            direction: 'desc'
          };
          break;
        case 'firstArrivalDate-desc':
          sort = {
            field: 'firstArrivalDate',
            direction: 'desc'
          };
          break;
        case 'leader-desc':
          sort = {
            field: 'leader',
            direction: 'desc'
          };
          break;
        case 'id-desc':
        default:
          sort = {
            field: 'id',
            direction: 'desc'
          };
          isDefault = true;
          break;
      }
      this.$store.dispatch('SET_SETTINGS', {sort: sort});
      this.$store.dispatch('UPDATE_STORE');

      if (isDefault) {
        this.$cookies.remove("sort");
      } else {
        this.$cookies.set("sort", sort);
      }
    },
  },
  comments: {
    VueSelect
  }
}
</script>

<style scoped>
  .sort__caption {
    display: block;
    padding: 15px 10px 15px 0;
    margin: 0;
  }
</style>